(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["simple-as-seen-in"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vm-press')) {
  customElements.define('vm-press', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.vm-press__track');
      this.group = this.querySelector('.vm-press__group');
      this.pause = this.querySelector('.vm-press__pause');
      this.media = matchMedia('(prefers-reduced-motion: reduce)');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.pause.addEventListener('click', () => {
        const paused = this.toggleAttribute('data-paused');
        this.pause.setAttribute('aria-pressed', String(paused));
      }, options);
      this.addEventListener('shopify:block:select', () => {
        this.setAttribute('data-paused', '');
        this.pause.setAttribute('aria-pressed', 'true');
        this.removeAttribute('data-running');
        this.track.querySelectorAll('[data-clone]').forEach(clone => clone.remove());
      }, options);
      this.addEventListener('shopify:block:deselect', () => this.measure(), options);
      this.media.addEventListener('change', () => this.measure(), options);
      this.group.querySelectorAll('img').forEach(image => image.addEventListener('load', () => this.measure(), options));
      this.observer = new ResizeObserver(() => this.measure());
      this.observer.observe(this);
      this.measure();
    }
    measure() {
      this.track.querySelectorAll('[data-clone]').forEach(clone => clone.remove());
      const running = this.dataset.animate === 'true' && !this.media.matches && this.group.children.length > 0;
      this.toggleAttribute('data-running', running);
      this.pause.hidden = !running;
      if (!running) return;
      const width = this.group.getBoundingClientRect().width;
      if (!width) return;
      this.style.setProperty('--vp-distance', `${width}px`);
      const count = Math.ceil(this.clientWidth / width) + 1;
      for (let i = 0; i < count; i++) {
        const clone = this.group.cloneNode(true);
        clone.setAttribute('data-clone', '');
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('aria-label');
        clone.inert = true;
        clone.querySelectorAll('[data-shopify-editor-block]').forEach(el => el.removeAttribute('data-shopify-editor-block'));
        clone.querySelectorAll('a').forEach(link => link.setAttribute('tabindex', '-1'));
        this.track.appendChild(clone);
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simple-experts"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vm-experts')) {
  customElements.define('vm-experts', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.vm-experts__track');
      if (!this.track) return;
      this.cards = [...this.querySelectorAll('.vm-experts__card')];
      this.buttons = [...this.querySelectorAll('[data-slide]')];
      this.previous = this.querySelector('[data-previous]');
      this.next = this.querySelector('[data-next]');
      this.progress = this.querySelector('.vm-experts__progress');
      this.arrows = this.querySelector('.vm-experts__arrows');
      this.status = this.querySelector('.vm-experts__status');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.querySelectorAll('.vm-experts__toggle').forEach(button => {
        const more = this.querySelector(`#${CSS.escape(button.getAttribute('aria-controls'))}`);
        more.hidden = true;
        button.hidden = false;
        button.setAttribute('aria-expanded', 'false');
        button.textContent = button.dataset.more;
        button.addEventListener('click', () => {
          more.hidden = !more.hidden;
          button.setAttribute('aria-expanded', String(!more.hidden));
          button.textContent = more.hidden ? button.dataset.more : button.dataset.less;
        }, options);
      });
      this.buttons.forEach((button, index) => button.addEventListener('click', () => this.go(index), options));
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        if (['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
          event.preventDefault();
          if (event.key === 'Home') this.go(0);
          else if (event.key === 'End') this.go(this.cards.length - 1);
          else this.move(event.key === 'ArrowLeft' ? -1 : 1);
        }
      }, options);
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      }, { ...options, passive: true });
      this.addEventListener('shopify:block:select', event => {
        const index = this.cards.indexOf(event.target.closest('.vm-experts__card'));
        if (index >= 0) this.go(index, true);
      }, options);
      this.observer = new ResizeObserver(() => this.measure());
      this.observer.observe(this.track);
      this.setAttribute('data-enhanced', '');
      this.measure();
    }
    measure() {
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const first = this.cards[0]?.getBoundingClientRect().left || 0;
      this.positions = this.cards.map(card => Math.min(max, card.getBoundingClientRect().left - first));
      this.buttons.forEach((button, index) => { button.hidden = index > 0 && Math.abs(this.positions[index] - this.positions[index - 1]) < 1; });
      this.progress.hidden = this.arrows.hidden = max < 2;
      this.update();
    }
    move(direction) {
      const indices = this.buttons.map((button, index) => button.hidden ? -1 : index).filter(index => index >= 0);
      this.go(indices[Math.max(0, Math.min(indices.length - 1, indices.indexOf(this.active) + direction))]);
    }
    go(index, instant = false) {
      if (index === undefined) return;
      this.track.scrollTo({ left: this.positions[index], behavior: instant || matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    update() {
      let active = 0;
      this.positions.forEach((position, index) => {
        if (!this.buttons[index].hidden && Math.abs(position - this.track.scrollLeft) < Math.abs(this.positions[active] - this.track.scrollLeft)) active = index;
      });
      this.previous.disabled = this.track.scrollLeft < 2;
      this.next.disabled = this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 2;
      this.buttons.forEach((button, index) => { if (index === active) button.setAttribute('aria-current', 'true'); else button.removeAttribute('aria-current'); });
      if (this.active !== active) {
        this.active = active;
        this.status.textContent = this.progress.hidden ? '' : this.buttons[active]?.getAttribute('aria-label') || '';
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simple-how-to-use"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vm-how-to-use')) {
  customElements.define('vm-how-to-use', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.vm-htu__track');
      if (!this.track) return;
      this.steps = [...this.querySelectorAll('.vm-htu__step')];
      this.buttons = [...this.querySelectorAll('[data-step]')];
      this.nav = this.querySelector('.vm-htu__nav');
      this.status = this.querySelector('.vm-htu__status');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.buttons.forEach((button, index) => button.addEventListener('click', () => this.go(index), options));
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      }, { ...options, passive: true });
      this.track.addEventListener('keydown', (event) => {
        if (event.target !== this.track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const visible = this.buttons.map((button, index) => button.hidden ? -1 : index).filter(index => index >= 0);
        const position = visible.indexOf(this.active);
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? visible.length - 1 : position + (event.key === 'ArrowRight' ? 1 : -1);
        this.go(visible[Math.max(0, Math.min(visible.length - 1, next))]);
      }, options);
      this.addEventListener('shopify:block:select', (event) => {
        const index = this.steps.indexOf(event.target.closest('.vm-htu__step'));
        if (index >= 0) this.go(index, true);
      }, options);
      this.observer = new ResizeObserver(() => this.measure());
      this.observer.observe(this.track);
      this.setAttribute('data-enhanced', '');
      this.measure();
    }
    measure() {
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const first = this.steps[0]?.getBoundingClientRect().left || 0;
      this.positions = this.steps.map(step => Math.min(max, step.getBoundingClientRect().left - first));
      this.buttons.forEach((button, index) => { button.hidden = index > 0 && Math.abs(this.positions[index] - this.positions[index - 1]) < 1; });
      this.nav.hidden = max < 2;
      this.update();
    }
    go(index, instant = false) {
      if (index === undefined) return;
      this.track.scrollTo({ left: this.positions[index], behavior: instant || matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    update() {
      let active = 0;
      this.positions.forEach((position, index) => {
        if (!this.buttons[index].hidden && Math.abs(position - this.track.scrollLeft) < Math.abs(this.positions[active] - this.track.scrollLeft)) active = index;
      });
      this.buttons.forEach((button, index) => { if (index === active) button.setAttribute('aria-current', 'step'); else button.removeAttribute('aria-current'); });
      if (active !== this.active) {
        this.active = active;
        this.status.textContent = this.nav.hidden ? '' : this.buttons[active]?.getAttribute('aria-label') || '';
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simple-ingredients"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vm-ingredients')) {
    customElements.define('vm-ingredients', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.sni__track');
        this.cards = [...this.querySelectorAll('.sni__card')];
        this.dots = [...this.querySelectorAll('.sni__dot')];
        if (!this.track || !this.cards.length) return;
        this.setAttribute('data-ready', '');
        this.onClick = (event) => {
          const arrow = event.target.closest('[data-direction]');
          const dot = event.target.closest('[data-index]');
          if (arrow) this.go(this.index + Number(arrow.dataset.direction));
          if (dot) this.go(Number(dot.dataset.index));
        };
        this.onKey = (event) => {
          const destinations = { ArrowLeft: this.index - 1, ArrowRight: this.index + 1, Home: 0, End: this.last };
          if (event.key in destinations) { event.preventDefault(); this.go(destinations[event.key]); }
        };
        this.onScroll = () => { cancelAnimationFrame(this.frame); this.frame = requestAnimationFrame(() => this.update()); };
        this.onSelect = (event) => { const i = this.cards.indexOf(event.target.closest('.sni__card')); if (i >= 0) this.go(i); };
        this.addEventListener('click', this.onClick);
        this.track.addEventListener('keydown', this.onKey);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.addEventListener('shopify:block:select', this.onSelect);
        this.observer = new ResizeObserver(() => this.update());
        this.observer.observe(this.track);
        this.update();
      }
      update() {
        this.step = this.cards[0].getBoundingClientRect().width + 16;
        this.max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        this.last = Math.min(this.cards.length - 1, Math.ceil(Math.max(0, this.max - 1) / this.step));
        this.index = this.max - this.track.scrollLeft < 2 ? this.last : Math.min(this.last, Math.round(this.track.scrollLeft / this.step));
        this.dots.forEach((dot, i) => {
          dot.hidden = i > this.last;
          if (i === this.index) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
        });
        const previous = this.querySelector('[data-direction="-1"]');
        const next = this.querySelector('[data-direction="1"]');
        if (previous) previous.disabled = this.index === 0;
        if (next) next.disabled = this.index >= this.last;
        const pagination = this.querySelector('.sni__pagination');
        if (pagination) pagination.hidden = this.last === 0;
        const first = Math.floor((this.track.scrollLeft + 1) / this.step) + 1;
        const end = Math.min(this.cards.length, Math.ceil((this.track.scrollLeft + this.track.clientWidth) / this.step));
        this.querySelector('.sni__status').textContent = `Ingredients ${first}–${end} of ${this.cards.length}`;
      }
      go(index) {
        const target = Math.max(0, Math.min(this.last, index));
        this.track.scrollTo({ left: Math.min(this.max, target * this.step), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.track?.removeEventListener('keydown', this.onKey);
        this.track?.removeEventListener('scroll', this.onScroll);
        this.removeEventListener('shopify:block:select', this.onSelect);
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simple-why-love"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vm-why-love')) {
    customElements.define('vm-why-love', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.swl__toggle');
        if (!this.button) return;
        this.setAttribute('data-ready', '');
        this.setExpanded(false);
        this.onToggle = () => this.setExpanded(this.dataset.expanded !== 'true');
        this.onSelect = () => this.setExpanded(true);
        this.button.addEventListener('click', this.onToggle);
        this.addEventListener('shopify:block:select', this.onSelect);
      }
      setExpanded(expanded) {
        this.dataset.expanded = String(expanded);
        this.button.setAttribute('aria-expanded', String(expanded));
        this.button.textContent = expanded ? this.button.dataset.less : this.button.dataset.more;
      }
      disconnectedCallback() {
        this.button?.removeEventListener('click', this.onToggle);
        this.removeEventListener('shopify:block:select', this.onSelect);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
